import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { dateFormat } from '@carm/shared/constants/const-carm';
import { BaseApiService } from '@carm/_core/baseapi.service';
import * as dayjs from 'dayjs';
import { Observable} from 'rxjs';
import { environment } from 'src/environments/environment';
import { IDashboardCountResponse } from '../models/dashboard-count.model';

@Injectable()
export class DashboardCountService extends BaseApiService {
  constructor(protected injector: Injector) {
    super(injector);
  }

  public getAppealsCount(
    bn9: string,
    programId: string,
    minDate: Date,
    maxDate: Date,
  ): Observable<IDashboardCountResponse> {
    const endPoint = `${environment.baseApiUrls}/business/${bn9}/program/${programId}/dashboard/appeals`;

    const params = new HttpParams()
      .set('startDate', dayjs(minDate).format(dateFormat))
      .set('endDate', dayjs(maxDate).format(dateFormat));

    return this.httpAuthGet<IDashboardCountResponse>(endPoint, params);
  }

  public getPenaltiesCount(
    bn9: string,
    programId: string,
    minDate: Date,
    maxDate: Date,
  ): Observable<IDashboardCountResponse> {
    const endPoint = `${environment.baseApiUrls}/business/${bn9}/program/${programId}/dashboard/penalties`;

    const params = new HttpParams()
      .set('startDate', dayjs(minDate).format(dateFormat))
      .set('endDate', dayjs(maxDate).format(dateFormat));

    return this.httpAuthGet<IDashboardCountResponse>(endPoint, params);
  }

  public getCadReleaseCount(
    bn9: string,
    programId: string,
    minDate: Date,
    maxDate: Date,
  ): Observable<IDashboardCountResponse> {
    const endPoint = `${environment.baseApiUrls}/business/${bn9}/program/${programId}/dashboard/cad`;

    const params = new HttpParams()
      .set('startDate', dayjs(minDate).format(dateFormat))
      .set('endDate', dayjs(maxDate).format(dateFormat));

    return this.httpAuthGet<IDashboardCountResponse>(endPoint, params);
  }

  public getRulingsCount(
    bn9: string,
    programId: string
  ): Observable<IDashboardCountResponse> {
    const endPoint = `${environment.baseApiUrls}/business/${bn9}/program/${programId}/dashboard/rulings`;
    return this.httpAuthGet<IDashboardCountResponse>(endPoint);
  }

  public getStaffMemberAccessRequestsCount(
    bn9: string,
    programId: string
  ): Observable<IDashboardCountResponse> {
    const endPoint = `${environment.baseApiUrls}/business/${bn9}/program/${programId}/dashboard/staff-member-access-requests`;
    return this.httpAuthGet<IDashboardCountResponse>(endPoint);
  }

  public getThirdPartyAccessRequestsCount(
    bn9: string,
    programId: string
  ): Observable<IDashboardCountResponse> {
    const endPoint = `${environment.baseApiUrls}/business/${bn9}/program/${programId}/dashboard/third-party-access-requests`;
    return this.httpAuthGet<IDashboardCountResponse>(endPoint);
  }
}
